module.exports = __webpack_public_path__ + "img/pl_Beta Digitis - Gif.ad76b591.gif";